
import './loader.css'

export default function Loader() {
    return <div className="circle">
                <div className="noise animated w-[400px] h-[400px]" ></div>
           </div>
}